import React, {useState} from 'react';
import './styles.css';
import {ChoiceFreeformMapped} from '../../../../data/models/LessonContent/LessonConentMapped';
import {
  BRANCH_BACKGROUND_FREEFORM,
  BRANCH_IMAGE_FREEFORM,
  BRANCH_SHAPE_FREEFORM,
  BRANCH_TEXT_FREEFORM,
  CHALLENGE_BRANCH_HEADER,
  CHOICE_HEADER_NODE_TYPE,
  LessonContentFreeformImageChoice,
  LessonContentFreeformShapeChoice,
  LessonContentFreeformTextChoice,
} from '../../../../data/models/LessonContent/LessonContentBase';
import EditorSvgImage from '../../../Editor/FreeformElements/EditorSvgImage';
import EditorSvgText from '../../../Editor/FreeformElements/EditorSvgText';
import EditorSvgPath from '../../../Editor/FreeformElements/EditorSvgPath';
import './styles.css';
import Tooltip from '../../../../uiToolkit/Tooltip';
import {tapyblPlayerText} from '../../tapyblPlayerText';
import ChallengeInfoHeader from '../ChallengeInfoHeader/ChallengeInfoHeader';

interface Props {
  width: number;
  overlayNode: ChoiceFreeformMapped;
  onSelectFreeformChoice: (choiceId: string) => void;
  passingScore?: number;
}

const BASELINE_WIDTH = 500;

// TODO: temporal for demos - hides the question header bar over the freeform overlay
const HIDE_QUESTION_HEADER_FOR_DEMOS = true;

const ChoiceFreeformOverlay = React.memo(
  ({width, overlayNode, onSelectFreeformChoice, passingScore}: Props) => {
    const [showHeader, setShowHeader] = useState(true);

    const renderOverlays = () => {
      //TODO extract svg's into diiferent module
      return overlayNode.answers.map((answer, index) => {
        if (answer.ivNodeType === BRANCH_IMAGE_FREEFORM) {
          const imageNode = answer as LessonContentFreeformImageChoice;
          return (
            <EditorSvgImage
              image={{...imageNode}}
              key={index}
              source={imageNode.contentUrl || ''}
              aspect={imageNode.aspect}
              id={imageNode.internalId}
              onClick={() => {
                onSelectFreeformChoice(answer.internalId);
              }}
              width={width}
            />
          );
        }
        if (answer.ivNodeType === BRANCH_TEXT_FREEFORM) {
          const textNode = answer as LessonContentFreeformTextChoice;
          return (
            <EditorSvgText
              position={{...textNode}}
              text={textNode.text}
              color={textNode.color}
              key={index}
              onClick={() => {
                onSelectFreeformChoice(answer.internalId);
              }}
              width={0}
            />
          );
        }
        if (answer.ivNodeType === BRANCH_SHAPE_FREEFORM) {
          const shapeNode = answer as LessonContentFreeformShapeChoice;
          return (
            <EditorSvgPath
              shapePoints={shapeNode.overlayCoordinates}
              key={index}
              onClick={() => {
                onSelectFreeformChoice(answer.internalId);
              }}
              hideShape={!shapeNode.overlayVisible}
              width={width}
            />
          );
        }
        return <g key={index}></g>;
      });
    };

    const getVideoBackgroundAction = () => {
      const action = overlayNode.answers.find(
        item => item.ivNodeType === BRANCH_BACKGROUND_FREEFORM,
      );
      if (action) {
        return action.internalId;
      }
      return null;
    };

    const onClickCanvas = () => {
      const actionId = getVideoBackgroundAction();
      if (actionId) {
        onSelectFreeformChoice(actionId);
      }
    };

    return (
      <div>
        <div
          style={{width, height: width / 1.77}}
          className="ChoiceFreeformOverlayCanvas">
          <svg
            width={width}
            height={width / 1.77}
            viewBox={`0 0 ${BASELINE_WIDTH} ${BASELINE_WIDTH / 1.77}`}
            onClick={onClickCanvas}>
            {renderOverlays()}
          </svg>
          {/* TODO: temporal for demos - question header hidden */}
          {HIDE_QUESTION_HEADER_FOR_DEMOS ? null : showHeader ? (
            <div className="FreeformOverlayQuestionHeader">
              <ChallengeInfoHeader
                passingScore={passingScore}
                typeIcon={
                  overlayNode.ivNodeType === CHOICE_HEADER_NODE_TYPE
                    ? 'icon-typeChoice-Branch'
                    : 'icon-typeChallenge-Branch'
                }
                typeTitle={
                  overlayNode.ivNodeType === CHOICE_HEADER_NODE_TYPE
                    ? tapyblPlayerText.choiceBranch
                    : tapyblPlayerText.challengeBranch
                }
                haveMultipleAnswers={false}
                className="ChoiceInfo"
                question={overlayNode.question}
                isGradable={overlayNode.ivNodeType === CHALLENGE_BRANCH_HEADER}
              />
              <Tooltip tooltipText={tapyblPlayerText.hideQuestion}>
                <button
                  className="CollapseFreeformHeaderButton"
                  onClick={() => setShowHeader(false)}>
                  <span className="icon-typeChvron-Down"></span>
                </button>
              </Tooltip>
            </div>
          ) : (
            <div className="FreeformOverlayQuestionHeaderOpener">
              <Tooltip tooltipText={tapyblPlayerText.showQuestion}>
                <button
                  className="ExpandFreeformHeaderButton"
                  onClick={() => setShowHeader(true)}>
                  <span className="icon-typeChvron-Down"></span>
                </button>
              </Tooltip>
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default ChoiceFreeformOverlay;
